function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.5.5L6 8 2.5 4.5 0 7l6 6L16 3z"
});
function SvgCheck(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 13",
    ref: svgRef
  }, props), _ref);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default ForwardRef;